import React from 'react';
import { useTranslation } from 'react-i18next';

import Avatar from '@common/Avatar';
import { ContactsQuery_contacts_contacts as IContact } from '@typings/api';

interface Props {
  contact: IContact;
  isSelected?: boolean;
  onSelect: (contact: IContact) => void;
}

export function Contact(props: Props) {
  const { contact, isSelected, onSelect } = props;
  const { firstName, fullName, lastName, position, profilePicture } = contact;
  const { t } = useTranslation();

  function handleSelect() {
    onSelect(contact);
  }

  return (
    <button
      className={`group w-full border p-5 cursor-pointer flex space-x-4 relative transition-all duration-200 focus:outline-none focus:ring-transparent ${
        isSelected
          ? 'text-white bg-brand-400 border-brand-400'
          : 'text-gray-700 border-gray-300'
      }`}
      onClick={handleSelect}
      type="button"
    >
      <Avatar
        firstName={firstName}
        fontSize={2}
        lastName={lastName}
        size={5}
        src={profilePicture}
      />
      <div className="flex flex-col h-full text-left">
        <div className="mb-4 space-y-1">
          <div>{fullName}</div>
          <div
            className={`text-sm ${isSelected ? 'text-white' : 'text-gray-500'}`}
          >
            {position}
          </div>
        </div>
        <div
          className={`btn border w-32 mt-auto ${
            isSelected
              ? 'text-white border-white'
              : 'border-gray-700 group-hover:border-brand-400 group-hover:text-brand-400'
          }`}
        >
          {isSelected ? t('button.chosen') : t('button.choose')}
        </div>
        <div className="absolute bottom-0 left-0 w-0 group-hover:w-full h-1 bg-brand-400 transition-width duration-300 ease-in" />
      </div>
    </button>
  );
}
